import React, { useState, useEffect } from 'react';
import { GetAllpromotionByIdApi } from "../../../api/request/ib/ibpromotion.js";
import { useParams } from "react-router-dom";
import { Spin } from "antd";

export default function PromotionView() {

    const params = useParams();
    const [promotionDetails, setPromotionDetails] = useState("");
    const [isPromotionDetailsLoading, setIsPromotionDetailsLoading] = useState(false);

    const getPromotionById = async () => {
        try {
            setIsPromotionDetailsLoading(true);
            const { data } = await GetAllpromotionByIdApi(params.kitId);
            setPromotionDetails(data?.data);
            setIsPromotionDetailsLoading(false);

            // if (data?.data?.url) {
            //     window.open(data.data.url, '_blank', 'noopener,noreferrer');
            // }
        } catch (error) {
            setIsPromotionDetailsLoading(false);
        }
    };

    useEffect(() => {
        getPromotionById();
    }, []);

    return (
        <div className='p-5'>
            {
                isPromotionDetailsLoading ? (
                    <div className="flex justify-center flex-col my-[10%]">
                        <Spin size="large" />
                        <p className="primary text-center mt-2">Loading...</p>
                    </div>
                ) : (
                    <div id="promotionview" className={`rounded-lg border border-gray-300 ${promotionDetails?.height ? `h-[${promotionDetails.height}px]` : ''} ${promotionDetails?.width ? `w-[${promotionDetails.width}px]` : ''}`}>
                        <a href="http://localhost:3000/?tab=register&ref=YPNWDAFP" target="_blank" rel="noopener noreferrer">
                            <img
                                src={promotionDetails?.url}
                                alt="Promotion Kit"
                                className={`rounded-lg ${promotionDetails?.height ? `h-[${promotionDetails.height}px]` : ''} ${promotionDetails?.width ? `w-[${promotionDetails.width}px]` : ''}`}
                            />
                        </a>

                    </div>
                )
            }
        </div>
    );
}